import React from 'react';
import classNames from 'classnames';

import { useOrderContext } from '@/components/modals/SubmitOrder/helpers';
import { formatPriceWithCurrency } from '@/utils/format-price';

import { Props } from './types';

import styles from '../../SuccessStep.module.scss';

export const SuccessProposalDetails = ({ homeownerAddress, proposal, totalPrice }: Props) => {
  const state = useOrderContext();
  const isActivityDistributionModel = state.isDistribution;
  const isAccessDistribution = state.isAccessProgram && state.isDistribution;

  const totalPriceInformation = {
    title: isAccessDistribution ? 'SERVICES TOTAL' : 'Order total',
    value: totalPrice,
  };

  return (
    <div className={styles.details_block}>
      <span className={styles.block_title}>Proposal Details</span>
      <hr />
      <div className={styles.details_list}>
        <div className={styles.title_and_value}>
          <span className={styles.proposal_details_title}>Customer</span>
          <span
            className={classNames(
              styles.proposal_details_values,
              styles.proposal_details_values_bold,
            )}
          >
            {homeownerAddress.firstName} {homeownerAddress.lastName}
          </span>
        </div>
        {!isActivityDistributionModel && (
          <div className={styles.title_and_value}>
            <span className={styles.proposal_details_title}>PO Number</span>
            <span
              className={classNames(
                styles.proposal_details_values,
                styles.proposal_details_values_bold,
              )}
            >
              {proposal.number}
            </span>
          </div>
        )}
        <div className={styles.title_and_value}>
          <span className={styles.proposal_details_title}>System size</span>
          <span
            className={classNames(
              styles.proposal_details_values,
              styles.proposal_details_values_bold,
            )}
          >
            {proposal.systemSize}kW
          </span>
        </div>
        {isActivityDistributionModel && (
          <div className={styles.title_and_value}>
            <span className={styles.proposal_details_title}>Timberline Solar ES™</span>
            <span
              className={classNames(
                styles.proposal_details_values,
                styles.proposal_details_values_bold,
              )}
            >
              {proposal.timberlineShingles} Shingles
            </span>
          </div>
        )}
        <div className={styles.title_and_value}>
          <span className={styles.proposal_details_title}>Proposal name</span>
          <span
            className={classNames(
              styles.proposal_details_values,
              styles.proposal_details_values_bold,
            )}
          >
            {proposal.name}
          </span>
        </div>
        {!state.isPriceHidden && (
          <div className={styles.title_and_value}>
            <span className={styles.proposal_details_title}>{totalPriceInformation.title}</span>
            <span
              className={classNames(
                styles.proposal_details_values,
                styles.proposal_details_values_bold,
              )}
            >
              {formatPriceWithCurrency(totalPriceInformation.value)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
